import React from 'react';
import { Box } from '@mui/material';
import { numberWithCommasOrDash } from 'spw-shared/utils';
import { SpaceBetweenColumn } from 'spw-shared/globalComponents/grid';
import useUnitConversion from 'spw-components/unit-conversion/hooks';
import { BigKey, BigValue, BigValuePair, CardTitle } from './styles';

export const MacroSinglePageKeyDataPoints = ({
  showRsf,
  totalProgramRSF,
  totalProgramUSF,
  futureHeadcount,
  futureWorkSeats,
  testingPrefix,
}: {
  showRsf: boolean;
  totalProgramRSF: number;
  totalProgramUSF: number;
  futureHeadcount: number;
  futureWorkSeats: number;
  testingPrefix: string;
}) => {
  const { getUnit, convertToUnit } = useUnitConversion();
  return (
    <Box style={{ height: '214px' }}>
      <CardTitle data-testid={`${testingPrefix}_title`}>
        KEY DATA POINTS
      </CardTitle>
      <SpaceBetweenColumn>
        {showRsf && (
          <BigValuePair>
            <BigValue>
              {convertToUnit(totalProgramRSF, {
                unitType: 'area',
                formatter: numberWithCommasOrDash,
              })}
            </BigValue>
            <BigKey>Total Program {getUnit('rentable-area')}</BigKey>
          </BigValuePair>
        )}
        <BigValuePair>
          <BigValue data-testid={`${testingPrefix}_totalProgramUSF`}>
            {convertToUnit(totalProgramUSF, {
              unitType: 'area',
              formatter: numberWithCommasOrDash,
            })}
          </BigValue>
          <BigKey data-testid={`${testingPrefix}_totalProgramUSF_label`}>
            Total Program {getUnit('area')}
          </BigKey>
        </BigValuePair>
        <BigValuePair>
          <BigValue data-testid={`${testingPrefix}_futureHeadcount`}>
            {numberWithCommasOrDash(futureHeadcount)}
          </BigValue>
          <BigKey data-testid={`${testingPrefix}_futureHeadcount_label`}>
            Headcount
          </BigKey>
        </BigValuePair>
        <BigValuePair>
          <BigValue data-testid={`${testingPrefix}_futureWorkSeats`}>
            {numberWithCommasOrDash(futureWorkSeats)}
          </BigValue>
          <BigKey data-testid={`${testingPrefix}_futureWorkSeats_label`}>
            Work Seats
          </BigKey>
        </BigValuePair>
      </SpaceBetweenColumn>
    </Box>
  );
};
